import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../../components/BaseComponent';
import { HBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { Sync, EditSquare } from '../../../../components/Icon';
import { Modal, ModalControls } from '../../../../components/Modal';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { CompanySelection } from '../../../Companies/components/CompanySelection';

const Container = styled.div``;

const STATE = {
  active: false,
  selectedCompany: null,
};

/* eslint-disable react/prefer-stateless-function */
class BuyerCompanyFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  applySelection() {
    this.props.onChange(this.state.selectedCompany?.id);
    this.reset();
  }

  render() {
    return (
      <Container>
        <HBox left vCenter>
          <CompanyLabelById
            company_id={this.props.selectedCompanyId ? this.props.selectedCompanyId : this.props.value}
            key={this.props.value}
          />
          &nbsp;
          <Button small onClick={this.setStateFn({ active: true })}>
            <EditSquare />
          </Button>
        </HBox>
        {this.state.active ? (
          <Modal onClose={this.reset.bind(this)} title={this.lbl(`invoice.generating.buyer`)}>
            {this.state.selectedCompany ? (
              <>{this.state.selectedCompany.name ? this.state.selectedCompany.name : this.state.selectedCompany.name}</>
            ) : (
              <CompanySelection
                company={this.props.company}
                onSelect={selectedCompany => this.setState({ selectedCompany })}
              />
            )}
            <ModalControls>
              <Button onClick={this.applySelection.bind(this)} primary disabled={!this.state.selectedCompany}>
                {this.lbl('ok')}
              </Button>
              <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
            </ModalControls>
          </Modal>
        ) : null}
      </Container>
    );
  }
}

BuyerCompanyFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const BuyerCompanyField = compose(
  withConnect,
  withRouter,
)(BuyerCompanyFieldComp);
